import React from 'react';

function Footer() {
  return (
    <footer className="py-10 bg-slate-100 text-slate-800">
      <div className="container px-4 mx-auto">
        <div className="flex items-center justify-center">
          <span className="text-xs md:text-sm">© 2023 Training Research & Development, ITeMS. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
